import React, { useEffect, useRef, useState } from "react";
import { Form, Button, Container, Row, Col, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import PageHeader from "../../components/PageHeader/PageHeader";
import {
  ArrowLeftSquareFill,
  CaretDownFill,
  XCircleFill,
} from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import "./trainingQuiz.scss";
import CroppingModal from "../../components/Cropping Modal/CroppingModal";
import {
  postDetails,
  postMultipartDetails,
} from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import encrypt from "../../utils/helpers/encrypt";
import { useAppDispatch } from "../../store/storeRequests";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";

const AddTrainingQuiz: React.FC = () => {
  const [data, setData] = useState<any>([]);
  const [options, setOptions] = useState<string[]>([""]);
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  const [showWarning, setShowWarning] = useState(false);
  const [questionImagePreview, setQuestionImagePreview] = useState<
    string | null
  >(null);
  const [filePreviews, setFilePreviews] = useState<(string | null)[]>([null]);
  const [selectedFieldType, setSelectedFieldType] =
    useState<string>("Textual Option");
  const [showCropper, setShowCropper] = useState<boolean>(false);
  const [currentImage, setCurrentImage] = useState<string | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState<number | null>(
    null
  );
  const [folderId, setFolderId] = useState<string>("");
  const [question, setQuestion] = useState("");
  const [questionFile, setQuestionFile] = useState<File | null>(null);
  const [optionFiles, setOptionFiles] = useState<File[]>([]);
  const [points, setPoints] = useState(0);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const cmpMounted = useRef(false);
  const [folders, setFolders] = useState<{ id: string; folder_name: string }[]>(
    []
  );

  useEffect(() => {
    if (cmpMounted.current === true) return;
    cmpMounted.current = true;
    fetchQuizData();
  }, []);


  const fetchQuizData = async () => {
    try {
      dispatch(showLoader('Loading data...'));
      const response = await postDetails(APIList.GET_ALL_TRAINING_QUIZ_FOLDER, {});
      const trainingQuizFolders = response.data.filter((item:any) => item.isTrainingQuiz === 1)
      setData(trainingQuizFolders)

      const folderData = response.data.map((item: any) => ({
        id: item.id,
        folder_name: item.folder_name,
      }));
      setFolders(folderData);
      // console.log(folderData);

      if (folderData.length > 0) {
        handleQuizTypeChange(response.data[0].quiz_type);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally{
      dispatch(hideLoader());
  }
  };

  const handleQuizTypeChange = (type: number) => {
    let fieldType: string;
    switch (type) {
      case 1:
        fieldType = "Textual Option";
        break;
      case 2:
        fieldType = "Descriptive Option";
        break;
      case 3:
        fieldType = "Image Option";
        break;
      case 4:
        fieldType = "Image Ordering Option";
        break;
      default:
        fieldType = "Textual Option";
        break;
    }
    setSelectedFieldType(fieldType);
  };

  const handleAddOption = () => {
    setOptions([...options, ""]);
    setFilePreviews([...filePreviews, null]);
  };

  const handleOptionChange = (index: number, value: string) => {
    const newOptions = [...options];
    newOptions[index] = value;
    setOptions(newOptions);
  };

  const handleOptionSelect = (index: number) => {
    setSelectedOption(index);
    setShowWarning(true);
  };

  const handleQuestionImageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      setQuestionFile(file);

      const reader = new FileReader();
      reader.onloadend = () => {
        setCurrentImage(reader.result as string);
        setShowCropper(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImageChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      setOptionFiles((prev) => {
        const newFiles = [...prev];
        newFiles[index] = file;
        return newFiles;
      });

      const reader = new FileReader();
      reader.onloadend = () => {
        setCurrentImage(reader.result as string);
        setCurrentImageIndex(index);
        setShowCropper(true);
      };
      reader.readAsDataURL(file);

      const newOptions = [...options];
      newOptions[index] = file.name;
      setOptions(newOptions);
    }
  };

  const handleImageRemove = (index: number) => {
    const newPreviews = [...filePreviews];
    newPreviews[index] = null;
    setFilePreviews(newPreviews);
  };

  const handleRemoveOption = (index: number) => {
    setOptions(options.filter((_, i) => i !== index));
    setFilePreviews(filePreviews.filter((_, i) => i !== index));
  };

  const handleQuestionChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => setQuestion(e.target.value);

  const handleSelectedField = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => setSelectedFieldType(e.target.value);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!folderId) {
      console.error("Folder ID is missing");
      return;
    }

    if(points < 0){
      alert("Points cannot be negative")
      return
    }

    if (
      options.length === 0 ||
      !options.some((_, index) => selectedOption === index)
    ) {
      alert("Please add at least one option and select the correct answer.");
      return;
    }

    const formData = new FormData();

    const formattedOptions = options.map((option, index) => {
      if (selectedFieldType === "Image Ordering Option") {
        return {
          text: optionFiles[index]?.name || "",
          value: (index + 1).toString(),
        };
      } else {
        return {
          text: option,
          value: selectedOption === index ? "true" : "false",
        };
      }
    });

    if (questionFile) {
      formData.append("question_file", questionFile);
    }

    options.forEach((_, index) => {
      if (optionFiles[index]) {
        formData.append(`option_file`, optionFiles[index]);
      }
    });

    const quizTypeMap: { [key: string]: number } = {
      "Textual Option": 1,
      "Descriptive Option": 2,
      "Image Option": 3,
      "Image Ordering Option": 4,
    };

    const quizType = quizTypeMap[selectedFieldType] || 1;

    const payload = {
      folder_id: Number(folderId),
      quiz_type: quizType,
      question,
      options: formattedOptions,
      point: points,
    };

    formData.append("data", encrypt(payload));
    console.log(payload)

    try {
      const response = await postMultipartDetails(APIList.ADD_TRAINING_QUIZ, formData);
      console.log("Response:", response);
      redirectToQuizFolder();
      dispatch(showToast("Quiz Added Succesfully."));
      setTimeout(() => dispatch(hideToast()), 3000);
    } catch (error) {
      console.error("Error submitting quiz:", error);
    }
  };

  const redirectToQuizFolder = () => {
    navigate("/training-quiz");
  };

  const buttons = [
    {
      label: "Back to Quiz Folder",
      theme: "danger",
      icon: <ArrowLeftSquareFill />,
      onClick: redirectToQuizFolder,
    },
  ];

  const handleCrop = (croppedImage: string) => {
    if (currentImageIndex !== null) {
      const newFilePreviews = [...filePreviews];
      newFilePreviews[currentImageIndex] = croppedImage;
      setFilePreviews(newFilePreviews);
    } else {
      setQuestionImagePreview(croppedImage);
    }
    setShowCropper(false);
  };

  return (
    <LayoutContainer title="Add Training Quiz">
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100 mb-4">
        <h2>
          <i className="page-header-icon fa fa-home"></i>
          Add Quiz
        </h2>
      <PageHeader buttons={buttons} />
      </div>
      <div className="form-control-margin">
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col xs={6}>
              <Form.Group controlId="formFolder" className="mb-3">
                <Form.Label>Select Folder</Form.Label>
                <InputGroup>
                  <Form.Control
                    as="select"
                    className="form-select required-field"
                    value={folderId}
                    onChange={(e) => {
                      console.log(e);
                      setFolderId(e.target.value);
                    }}
                  >
                    <option value="">Please select folder</option>
                    {folders.map((folder) => (
                      <option key={folder.id} value={folder.id}>
                        {folder.folder_name}
                      </option>
                    ))}
                  </Form.Control>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col xs={6}>
              <Form.Group controlId="formFieldType" className="mb-3">
                <Form.Label>Select Quiz Type</Form.Label>
                <InputGroup>
                  <Form.Control
                    as="select"
                    className="required-field"
                    value={selectedFieldType}
                    onChange={handleSelectedField}
                  >
                    <option>Textual Option</option>
                    <option>Descriptive Option</option>
                    <option>Image Ordering Option</option>
                    <option>Image Option</option>
                  </Form.Control>
                </InputGroup>
              </Form.Group>
            </Col>
          </Row>

          <Form.Group controlId="formQuestion" className="mb-3">
            <Form.Label>Enter Question</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter question"
              className="form-question"
              onChange={handleQuestionChange}
              required
            />
          </Form.Group>

          <Form.Group controlId="formPoints" className="mb-3">
            <Form.Label>Enter Points</Form.Label>
            <Form.Control
              type="number"
              placeholder="Enter Points"
              className="form-points"
              onChange={(e) => setPoints(parseInt(e.target.value))}
              required
            />
          </Form.Group>

          <Form.Group controlId="formQuestionImage" className="mb-3">
            <Row>
              <Col xs={9}>
                <Form.Label>Question Image</Form.Label>
                <Form.Control
                  type="file"
                  onChange={handleQuestionImageChange}
                />
                <Form.Text className="text-muted">
                  Format Support jpg, jpeg, png
                </Form.Text>
              </Col>
              {questionImagePreview && (
                <Col xs={3} className="position-relative">
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <img
                      src={questionImagePreview}
                      alt="Selected"
                      style={{
                        maxWidth: "100px",
                        maxHeight: "100px",
                        objectFit: "cover",
                        border: "1px solid #ddd",
                        borderRadius: "5px",
                      }}
                    />
                    <XCircleFill
                      size={20}
                      className="text-danger"
                      style={{
                        position: "absolute",
                        top: "2px",
                        right: "2px",
                        cursor: "pointer",
                        zIndex: 1,
                      }}
                      onClick={() => setQuestionImagePreview(null)}
                    />
                  </div>
                </Col>
              )}
            </Row>
          </Form.Group>

          {selectedFieldType === "Textual Option" &&
            options.map((option, index) => (
              <Form.Group
                key={index}
                controlId={`formTextOption-${index}`}
                className="mb-3"
              >
                <Row className="align-items-center">
                  <Col xs={1}>
                    <Form.Check
                      type="radio"
                      name="correctAnswer"
                      checked={selectedOption === index}
                      onChange={() => handleOptionSelect(index)}
                    />
                  </Col>
                  <Col xs={6}>
                    <Form.Control
                      type="text"
                      value={option}
                      placeholder="Quiz Option"
                      onChange={(e) =>
                        handleOptionChange(index, e.target.value)
                      }
                      className="required-field"
                    />
                  </Col>
                  <Col xs={2}>
                    {index > 0 ? (
                      <Button
                        variant="secondary"
                        onClick={() => handleRemoveOption(index)}
                      >
                        × Remove
                      </Button>
                    ) : (
                      <Button
                        onClick={handleAddOption}
                        className="btn-add ml-2"
                      >
                        + Add More
                      </Button>
                    )}
                  </Col>
                </Row>
              </Form.Group>
            ))}

          {selectedFieldType === "Descriptive Option"}

          {selectedFieldType === "Image Option" &&
            options.map((option, index) => (
              <Form.Group
                key={index}
                controlId={`formImageOption-${index}`}
                className="mb-3"
              >
                <Row className="align-items-start">
                  <Col
                    className="d-flex justify-content-center align-items-center"
                    xs={1}
                  >
                    <Form.Check
                      type="radio"
                      name="correctAnswer"
                      checked={selectedOption === index}
                      onChange={() => handleOptionSelect(index)}
                    />
                  </Col>
                  <Col xs={3}>
                    <Form.Control
                      as="input"
                      type="file"
                      onChange={(e) =>
                        handleImageChange(
                          index,
                          e as React.ChangeEvent<HTMLInputElement>
                        )
                      }
                    />
                    <Form.Text className="text-muted">
                      Format Support jpg, jpeg, png
                    </Form.Text>
                  </Col>
                  {filePreviews[index] && (
                    <Col xs={3} className="position-relative">
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <img
                          src={filePreviews[index]!}
                          alt="Selected"
                          style={{
                            maxWidth: "100px",
                            maxHeight: "100px",
                            objectFit: "cover",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                          }}
                        />
                        <XCircleFill
                          size={20}
                          className="text-danger"
                          style={{
                            position: "absolute",
                            top: "2px",
                            right: "2px",
                            cursor: "pointer",
                            zIndex: 1,
                          }}
                          onClick={() => handleImageRemove(index)}
                        />
                      </div>
                    </Col>
                  )}
                  <Col xs={2}>
                    {index > 0 ? (
                      <Button
                        variant="secondary"
                        onClick={() => handleRemoveOption(index)}
                      >
                        × Remove
                      </Button>
                    ) : (
                      <Button
                        variant="danger"
                        onClick={handleAddOption}
                        className="ml-2"
                      >
                        + Add More
                      </Button>
                    )}
                  </Col>
                </Row>
              </Form.Group>
            ))}

          {selectedFieldType === "Image Ordering Option" &&
            options.map((option, index) => (
              <Form.Group
                key={index}
                controlId={`formImageOrder-${index}`}
                className="mb-3"
              >
                <Row className="align-items-start">
                  <Col xs={2}>
                    <Form.Control
                      type="text"
                      value={index + 1}
                      placeholder="Order"
                      onChange={(e) =>
                        handleOptionChange(index, e.target.value)
                      }
                      className="required-field"
                      readOnly
                    />
                  </Col>
                  <Col xs={3}>
                    <Form.Control
                      as="input"
                      type="file"
                      onChange={(e) =>
                        handleImageChange(
                          index,
                          e as React.ChangeEvent<HTMLInputElement>
                        )
                      }
                    />
                    <Form.Text className="text-muted">
                      Format Support jpg, jpeg, png
                    </Form.Text>
                  </Col>
                  {filePreviews[index] && (
                    <Col xs={3} className="position-relative">
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <img
                          src={filePreviews[index]!}
                          alt="Selected"
                          style={{
                            maxWidth: "100px",
                            maxHeight: "100px",
                            objectFit: "cover",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                          }}
                        />
                        <XCircleFill
                          size={20}
                          className="text-danger"
                          style={{
                            position: "absolute",
                            top: "2px",
                            right: "2px",
                            cursor: "pointer",
                            zIndex: 1,
                          }}
                          onClick={() => handleImageRemove(index)}
                        />
                      </div>
                    </Col>
                  )}
                  <Col xs={2}>
                    {index > 0 ? (
                      <Button
                        variant="secondary"
                        onClick={() => handleRemoveOption(index)}
                      >
                        × Remove
                      </Button>
                    ) : (
                      <Button
                        variant="danger"
                        onClick={handleAddOption}
                        className="ml-2"
                      >
                        + Add More
                      </Button>
                    )}
                  </Col>
                </Row>
              </Form.Group>
            ))}

          <div className="d-flex justify-content-center">
            <Button type="submit" className="btn-submit text-white">
              Submit
            </Button>
          </div>
        </Form>
      </div>

      <CroppingModal
        show={showCropper}
        handleClose={() => setShowCropper(false)}
        image={currentImage || ""}
        onCrop={handleCrop}
      />
    </LayoutContainer>
  );
};

export default AddTrainingQuiz;
